<!-- display addToOrderTemplate Icon/animated Icon or link-->
<button
  *ngIf="visible$ | async"
  type="button"
  name="addProduct"
  class="btn rounded-circle"
  [disabled]="disabled$ | async"
  [ngClass]="cssClass"
  (click)="openModal(modal)"
  data-testing-id="addToOrderTemplateButton"
  title="{{ 'account.order_template.add_to_template.button.add_to_template.label' | translate }}"
>
  <ng-container [ngSwitch]="displayType">
    <ng-template [ngSwitchCase]="'animated'">
      <!-- <fa-icon
        [icon]="['fas', 'heart']"
        [title]="'account.order_template.add_to_template.button.add_to_template.label' | translate"
      ></fa-icon> -->
      <i class="icon-heart"></i>
      <span class="share-label">{{
        'account.order_template.add_to_template.button.add_to_template.label' | translate
      }}</span>
    </ng-template>
    <ng-template [ngSwitchCase]="'icon'">
      <!-- <fa-icon
        [icon]="['fas', 'heart']"
        [title]="'account.order_template.add_to_template.button.add_to_template.label' | translate"
      ></fa-icon> -->
      <i
        class="icon-heart"
        title="{{ 'account.order_template.add_to_template.button.add_to_template.label' | translate }}"
      ></i>
    </ng-template>
    <ng-template ngSwitchDefault>
      {{ 'account.order_template.add_to_template.button.add_to_template.label' | translate }}
    </ng-template>
  </ng-container>
</button>

<ish-select-order-template-modal
  #modal
  (submitEmitter)="addProductToOrderTemplate($event)"
></ish-select-order-template-modal>
